import React, { useCallback, useMemo } from 'react'
import { makeStyles } from '@material-ui/styles'
import GrinFloatingPopup from 'components/common/menu/GrinFloatingPopup'
import { useDispatch, useSelector } from 'react-redux'
import { trackEvent } from 'utils/analyticsUtils'
import Actions from 'actions'
import useBiteClassification from 'hooks/useBiteClassification'
import TreatmentTrackingPanel from 'components/Patients/Timeline/ScanSummary/TreatmentTracking/TreatmentTrackingPanel'
import { scrollBar } from 'styles/theme'

const SPACING_SIZE = 10

const useStyles = makeStyles(() => ({
  root: {
    overflowY: 'auto',
    overflowX: 'hidden',
    width: ({ width, biteEnabled }) =>
      biteEnabled ? Math.max((width || 0) - SPACING_SIZE, 540) : width - SPACING_SIZE,
    maxWidth: 'calc(100vw - 32px)',
    height: ({ height }) => height - SPACING_SIZE,
    ...scrollBar,
    borderRadius: 10
  },
  tagScanBody: {
    padding: 10
  }
}))

const TagScanModal = ({ anchorEl, patientSwitchableViewRef, scanId }) => {
  const patientSwitchableViewSize = useMemo(
    () => (patientSwitchableViewRef?.current ? patientSwitchableViewRef?.current?.getBoundingClientRect() : {}),
    [patientSwitchableViewRef]
  )

  const { isEnabled: biteEnabled } = useBiteClassification()
  const classes = useStyles({
    biteEnabled,
    width: patientSwitchableViewSize?.width,
    height: patientSwitchableViewSize?.height
  })
  const dispatch = useDispatch()
  const { isOpen } = useSelector(state => state.hiReducer.tagScanModal)

  const handleClose = useCallback(() => {
    trackEvent('Tag scan modal - Closed')
    dispatch(
      Actions.setTagScanModalOpen({
        isOpen: false
      })
    )
  }, [dispatch])

  return !scanId ? (
    <></>
  ) : (
    <GrinFloatingPopup
      placement="right-start"
      className={classes.root}
      containerClassName={classes.container}
      customAnchorEl={anchorEl}
      open={isOpen}
      onClose={handleClose}
      grinPopperProps={{
        modifiers: {
          ...(biteEnabled && {
            flip: { enabled: false },
            preventOverflow: { boundariesElement: 'viewport', padding: 10 }
          }),
          offset: {
            enabled: true,
            offset: '-45, 30'
          }
        }
      }}
    >
      <div id="tag-scan-popup" className={classes.tagScanBody}>
        <TreatmentTrackingPanel scanId={scanId} />
      </div>
    </GrinFloatingPopup>
  )
}

export default TagScanModal
